import LayerCustomerHelp from './includes/layer-customer-accompaniement.module';
import StickyCustomerHelp from './includes/sticky-customer-accompaniement.module';
class CustomerAccompaniementMesh extends lm.Composant {
  constructor(id) {
    super(id);
    const stickyCustomerHelpInstance = new StickyCustomerHelp(id);
    stickyCustomerHelpInstance.init();
    const layerCustomerHelpInstance = new LayerCustomerHelp(id);
    layerCustomerHelpInstance.init();
  }
}
lm.DOMReady(function () {
  const customerHelpComponents = document.querySelectorAll('.component-customeraccompaniementmesh');
  customerHelpComponents.forEach(component => {
    const componentId = component.getAttribute('id');
    if (componentId) {
      new CustomerAccompaniementMesh(componentId);
    }
  });
});